import { Component } from '@angular/core';
import { Event } from '@angular/router';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class AccordionComponent {
  showContent(event: any) {
    //parent = event.target.parent.parentElement;
    console.log(event.currentTarget.parentElement);
  }
}
